<app-modal-wrapper
  [title]="editingId ? 'Edit Integration Field' : 'New Integration Field'"
  [isDirty]="form.dirty"
  [formValid]="form.valid"
  [showSaveButton]="true"
  [saveLoading]="saving"
  [keepEditingLabel]="editingId ? 'Keep editing' : 'Keep creating'"
  (save)="save()"
  (closeRequest)="ref.close()"
>
  <form [formGroup]="form" class="grid grid-cols-1 gap-6 md:grid-cols-2">
    <div>
      <app-input-dropdown
        label="System"
        [options]="systemOptions"
        optionLabel="label"
        optionValue="id"
        placeholder="Select a system..."
        formControlName="integrationSystemId"
        [required]="true"
      ></app-input-dropdown>
    </div>

    <div>
      <app-input-dropdown
        label="Entity"
        [options]="entityTypeOptions"
        optionLabel="displayName"
        optionValue="code"
        placeholder="Select an entity..."
        formControlName="entityType"
        [required]="true"
      ></app-input-dropdown>
    </div>

    <div>
      <app-input-text
        label="External Key"
        formControlName="externalKey"
        placeholder="apelido_cliente"
        [required]="true"
      ></app-input-text>
    </div>

    <div>
      <app-input-text
        label="Label"
        formControlName="label"
        placeholder="Finpac Client Code"
        [required]="true"
      ></app-input-text>
    </div>

    <div>
      <app-input-dropdown
        label="Data Type"
        [options]="dataTypeOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="Select a type..."
        formControlName="dataType"
        [required]="true"
      ></app-input-dropdown>
    </div>

    <div>
      <app-input-text
        label="Sort Order"
        formControlName="sortOrder"
      ></app-input-text>
    </div>

    <div class="md:col-span-2">
      <app-input-text
        label="Description"
        formControlName="description"
        placeholder="Optional helper text shown in entity forms"
      ></app-input-text>
    </div>

    <div class="md:col-span-2">
      <app-input-text
        label="Validation Regex"
        formControlName="validationRegex"
        placeholder="Optional"
      ></app-input-text>
    </div>

    <div class="md:col-span-2 grid grid-cols-2 gap-3 md:grid-cols-5">
      <div
        class="flex items-center gap-3 p-3 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 transition-colors"
        (click)="requiredCheck.click()"
      >
        <div class="relative flex items-center justify-center w-5 h-5">
          <input #requiredCheck type="checkbox" formControlName="required"
            class="peer appearance-none w-5 h-5 border border-gray-300 rounded bg-white checked:bg-[var(--primary-500)] checked:border-[var(--primary-500)] focus:ring-0 transition-all cursor-pointer"
            (click)="$event.stopPropagation()" />
          <i class="pi pi-check absolute text-white text-[10px] font-bold opacity-0 peer-checked:opacity-100 pointer-events-none transition-opacity duration-200"></i>
        </div>
        <label class="font-bold text-gray-700 text-sm select-none cursor-pointer">Required</label>
      </div>

      <div
        class="flex items-center gap-3 p-3 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 transition-colors"
        (click)="visibleCheck.click()"
      >
        <div class="relative flex items-center justify-center w-5 h-5">
          <input #visibleCheck type="checkbox" formControlName="visibleInForm"
            class="peer appearance-none w-5 h-5 border border-gray-300 rounded bg-white checked:bg-[var(--primary-500)] checked:border-[var(--primary-500)] focus:ring-0 transition-all cursor-pointer"
            (click)="$event.stopPropagation()" />
          <i class="pi pi-check absolute text-white text-[10px] font-bold opacity-0 peer-checked:opacity-100 pointer-events-none transition-opacity duration-200"></i>
        </div>
        <label class="font-bold text-gray-700 text-sm select-none cursor-pointer">Visible</label>
      </div>

      <div
        class="flex items-center gap-3 p-3 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 transition-colors"
        (click)="editableCheck.click()"
      >
        <div class="relative flex items-center justify-center w-5 h-5">
          <input #editableCheck type="checkbox" formControlName="editable"
            class="peer appearance-none w-5 h-5 border border-gray-300 rounded bg-white checked:bg-[var(--primary-500)] checked:border-[var(--primary-500)] focus:ring-0 transition-all cursor-pointer"
            (click)="$event.stopPropagation()" />
          <i class="pi pi-check absolute text-white text-[10px] font-bold opacity-0 peer-checked:opacity-100 pointer-events-none transition-opacity duration-200"></i>
        </div>
        <label class="font-bold text-gray-700 text-sm select-none cursor-pointer">Editable</label>
      </div>

      <div
        class="flex items-center gap-3 p-3 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 transition-colors"
        (click)="uniqueCheck.click()"
      >
        <div class="relative flex items-center justify-center w-5 h-5">
          <input #uniqueCheck type="checkbox" formControlName="isUnique"
            class="peer appearance-none w-5 h-5 border border-gray-300 rounded bg-white checked:bg-[var(--primary-500)] checked:border-[var(--primary-500)] focus:ring-0 transition-all cursor-pointer"
            (click)="$event.stopPropagation()" />
          <i class="pi pi-check absolute text-white text-[10px] font-bold opacity-0 peer-checked:opacity-100 pointer-events-none transition-opacity duration-200"></i>
        </div>
        <label class="font-bold text-gray-700 text-sm select-none cursor-pointer">Unique</label>
      </div>

      <div
        class="flex items-center gap-3 p-3 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 transition-colors"
        (click)="enabledCheck.click()"
      >
        <div class="relative flex items-center justify-center w-5 h-5">
          <input #enabledCheck type="checkbox" formControlName="enabled"
            class="peer appearance-none w-5 h-5 border border-gray-300 rounded bg-white checked:bg-[var(--primary-500)] checked:border-[var(--primary-500)] focus:ring-0 transition-all cursor-pointer"
            (click)="$event.stopPropagation()" />
          <i class="pi pi-check absolute text-white text-[10px] font-bold opacity-0 peer-checked:opacity-100 pointer-events-none transition-opacity duration-200"></i>
        </div>
        <label class="font-bold text-gray-700 text-sm select-none cursor-pointer">Enabled</label>
      </div>
    </div>
  </form>
</app-modal-wrapper>
